import React from 'react';
import classNames from 'classnames';
import Transition from '@/components/NewCart/Transition';
import styles from '@/components/NewCart/Reactions.module.css';

export enum reaction {
  like = '👍',
  love = '😍',
  confusion = '🤔',
}

const duration = 200;

const bubble = {
  duration,
  transitionStyles: {
    entering: { transform: 'translateY(100%)' },
    entered: { transform: 'translateY(0)' },
    exiting: { opacity: 0, display: 'none' },
    exited: { opacity: 0 },
  },
  defaultStyle: {
    opacity: 1,
    transition: `transform ${duration}ms linear`,
    transform: 'translateY(100%)',
  },
};

export interface Reaction {
  id?: number;
  emoji: reaction;
  label: string;
}

interface Props {
  reaction: Reaction;
  onClick: (reaction: Reaction) => void;
  setPrimary: () => void;
  className: string;
  index: number;
  show: boolean;
  isPicked: boolean;
}

const ReactionComponent = ({ reaction, onClick, setPrimary, className, index, show, isPicked }: Props): JSX.Element => {
  const { emoji, label } = reaction;

  const handleClick = () => {
    if (!onClick) return;
    onClick(reaction);
  };

  const element = (() => {
    const emojiElement = <div className={styles.emoji}>{emoji}</div>;

    const labelElement = <span className={styles.label}>{label}</span>;

    const fade = {
      duration: 0,
      transitionStyles: {
        entering: { opacity: 1 },
        entered: { opacity: 1 },
        exiting: { opacity: 1 },
        exited: { opacity: 0 },
      },
      defaultStyle: {
        opacity: 0,
      },
    };

    return (
      <div className={classNames(styles.child, className, styles.childWithHover)} onClick={handleClick} onMouseEnter={setPrimary}>
        {isPicked ? (
          <Transition show={show} {...fade}>
            {emojiElement}
            {labelElement}
          </Transition>
        ) : (
          <>
            {emojiElement}
            {labelElement}
          </>
        )}
      </div>
    );
  })();

  return (
    <Transition show={show || isPicked} {...bubble}>
      <div className={classNames(styles.child, className, styles.childWithHover)} onMouseEnter={setPrimary}>
        {element}
      </div>
    </Transition>
  );
};

export default ReactionComponent;
